import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import Typography from '@mui/material/Typography'

// helpers
import { cartTotal } from 'lib/cart/decorators/cartForm'
import { centsToDollars } from 'lib/helpers/money'

const TransactionTotal = props => {
  const {
    account,
    campers,
    sessions,
    cartForm // via redux state
  } = props

  const total = centsToDollars(
    cartTotal({ account, cartForm, campers, sessions })
  )

  return (
    <Box my={1} display='flex'>
      <Box display='flex' flexGrow={1}>
        <Typography color='text.secondary'>Cart Total</Typography>
      </Box>
      <Box display='flex'>
        <Typography>{total}</Typography>
      </Box>
    </Box>
  )
}

export default TransactionTotal
